import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { initAnalytics, trackEvent } from 'services/analytics';
import { ANALYTICS_EVENTS } from 'services/analytics/events';

void initAnalytics().then(() => {
  trackEvent(ANALYTICS_EVENTS.APP_SESSION_START);
});

// TODO-AUDIT: with new version, ReactDom.render is replaced by createRoot
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
